import React from 'react';

import { formatResizeDisplay, formatTokenCount } from '../../utils/formatters';

const AnalysisResultMetaBadges = ({
  analysisResult,
  modelName,
  useEbayRag,
  useNotesRag,
  assumeHiddenItems,
}) => {
  const analysisUsage = (analysisResult && typeof analysisResult.usage === 'object') ? analysisResult.usage : {};
  const inputTokens = analysisUsage.prompt_tokens ?? analysisUsage.input_tokens ?? null;
  const outputTokens = analysisUsage.completion_tokens ?? analysisUsage.output_tokens ?? null;
  const totalTokens = analysisUsage.total_tokens ?? (
    Number.isFinite(Number(inputTokens)) && Number.isFinite(Number(outputTokens))
      ? (Number(inputTokens) + Number(outputTokens))
      : null
  );
  const cacheHit = (
    analysisResult?.cache_hit === true ||
    String(analysisResult?.analysis_source || '').toLowerCase() === 'cache'
  );
  const analysisSourceLabel = cacheHit ? 'CACHE' : 'LIVE';
  const analysisSourceClass = cacheHit
    ? 'bg-cyan-100 text-cyan-700'
    : 'bg-slate-200 text-slate-700';

  return (
    <div className="mb-3 sm:mb-4">
      <div className="flex flex-wrap gap-2 text-xs font-mono">
        <span className="bg-slate-200 text-slate-700 px-2 py-1 rounded">
          Model: {analysisResult.model || modelName || 'N/A'}
        </span>
        <span className="bg-emerald-100 text-emerald-700 px-2 py-1 rounded">
          Resize: {formatResizeDisplay(analysisResult.resize_mode)}
        </span>
        <span className="bg-amber-100 text-amber-700 px-2 py-1 rounded">
          Compression: {analysisResult.compression_mode || 'N/A'}
        </span>
        <span className="bg-cyan-100 text-cyan-700 px-2 py-1 rounded">
          eBay RAG: {(
            analysisResult.use_ebay_rag !== undefined
              ? Boolean(analysisResult.use_ebay_rag)
              : useEbayRag
          )
            ? `on (${Number(analysisResult.ebay_rag_result_count || 0)} refs)`
            : 'off'}
        </span>
        <span className="bg-emerald-100 text-emerald-700 px-2 py-1 rounded">
          Notes RAG: {(
            analysisResult.use_notes_rag !== undefined
              ? Boolean(analysisResult.use_notes_rag)
              : useNotesRag
          )
            ? `on (${Number(analysisResult.notes_rag_example_count || 0)} examples)`
            : 'off'}
        </span>
        <span className="bg-fuchsia-100 text-fuchsia-700 px-2 py-1 rounded">
          Hidden Items: {(
            analysisResult.assume_hidden_items !== undefined
              ? Boolean(analysisResult.assume_hidden_items)
              : assumeHiddenItems
          ) ? 'on' : 'off'}
        </span>
        {((analysisResult.analysis_duration_ms !== undefined && analysisResult.analysis_duration_ms !== null) ||
          (analysisResult.duration_ms !== undefined && analysisResult.duration_ms !== null)) && (
          <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded">
            Speed: {Number(analysisResult.analysis_duration_ms || analysisResult.duration_ms).toFixed(0)}ms
          </span>
        )}
        {(
          analysisResult.analysis_cost_display !== undefined ||
          analysisResult.cost_display !== undefined ||
          analysisResult.analysis_cost !== undefined ||
          analysisResult.cost !== undefined
        ) && (
          <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded">
            Cost: {
              analysisResult.analysis_cost_display ||
              analysisResult.cost_display ||
              ((analysisResult.analysis_cost !== undefined && analysisResult.analysis_cost !== null)
                ? `$${Number(analysisResult.analysis_cost).toFixed(4)}`
                : ((analysisResult.cost !== undefined && analysisResult.cost !== null)
                  ? `$${Number(analysisResult.cost).toFixed(4)}`
                  : 'N/A'))
            }
          </span>
        )}
        <span className={`px-2 py-1 rounded font-bold ${analysisSourceClass}`}>
          Src: {analysisSourceLabel}
        </span>
        <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded">
          In Tok: {formatTokenCount(inputTokens)}
        </span>
        <span className="bg-violet-100 text-violet-700 px-2 py-1 rounded">
          Out Tok: {formatTokenCount(outputTokens)}
        </span>
        <span className="bg-emerald-100 text-emerald-700 px-2 py-1 rounded">
          Tot Tok: {formatTokenCount(totalTokens)}
        </span>
      </div>
    </div>
  );
};

export default AnalysisResultMetaBadges;
